import { Country, State, City } from "country-state-city";  

const countries = Country.getAllCountries(); 
export const countrieList = countries.map((country) => ({
    label: country.name,
    value: country.name,
}));